import React, { Component } from 'react'
import { getSelectedWeekDates, getWeekDays } from 'lib/services'
import RoutingConstants from 'lib/RoutingConstants';
import { post, get } from 'lib/api';
import Loader from 'lib/loader';
import ReactResizeDetector from 'react-resize-detector';
import Dashboard from './Dashboard'
import history from '../../history'

export const PlanMessage = () => (
  <div className="modal fade in build-plan">
    <div className="modal-dialog">
      <div className="modal-content">
          
        <div className="create-plan-popup-box">
        
          <div className="card-bg text-center sample-msg">
        
            {/* <h4> Welcome to Prep Day! </h4> */}
            <p> Thanks! We’re building an example plan with fan favorite recipes to show you the ropes . </p>
            {/* <span className="help-content"> We'll use this starter plan to help teach you the ropes! </span> */}
          </div>
        </div>
      </div>
    </div>
  </div>
)


class SampleDashboard extends Component {

  constructor(props) {
    super(props);

    const weekStartEnd = getSelectedWeekDates('currentWeek');
    const dayDates = this.props.location && this.props.location.state && this.props.location.state.dayDates ? this.props.location.state.dayDates : getWeekDays(weekStartEnd);
    const nextWeekStartEnd = getSelectedWeekDates('nextWeek',weekStartEnd);
    const nextDayDates = getWeekDays(nextWeekStartEnd);
    let vegan = this.props.location && this.props.location.state ? this.props.location.state.vegan : 'no'
    const servingSize = this.props.location && this.props.location.state ? this.props.location.state.servingSize : 2
    const weekStartDate = `${dayDates[0].Year}-${dayDates[0].Month}-${dayDates[0].date}`;
    const weekStartDateEnd = `${dayDates[6].Year}-${dayDates[6].Month}-${dayDates[6].date}`;
    if(localStorage.getItem('vegan')) {
      vegan = localStorage.getItem('vegan')
    }
    if(window.location.pathname === '/newUser') {
      localStorage.setItem('newUser','newUser')
    } else {
      localStorage.removeItem('newUser')
    }
    const planMessage = this.props.location && this.props.location.state && this.props.location.state.planMessage ? this.props.location.state.planMessage : false
    const samplePopup = this.props.location && this.props.location.state && this.props.location.state.samplePopup ? this.props.location.state.samplePopup : true
    this.state= {
      dayDates,
      nextDayDates,
      selectDate: null,
      inputs: {
        cooking_data: [],
        meal_plan_data: [],
        week_start_date: weekStartDate,
        week_end_date: weekStartDateEnd,
        groceryData: []
      },
      loader: false, 
      planMessage, 
      samplePopup,
      vegan,
      servingSize,
      selectWeek: dayDates,
      error: false,
      groceryCategory:['Produce','Dairy & Eggs','Meat & Seafood', 'Canned & Packaged', 'Spices & Condiments'],
      isMobile: false
    }
  }

  onResize() {
    window.scrollTo(0,0)
    if(window.innerWidth < 768) {
      this.setState({ isMobile: true }) 
    } else {
      this.setState({ isMobile: false }) 
    }
  }
  
  samplePopup() {
    const { dayDates, nextDayDates, selectDate, error } = this.state
    const startWeekDate = `${dayDates[0].halfMonth} ${dayDates[0].date}`;
    const endWeekDate = `${dayDates[6].halfMonth} ${dayDates[6].date}`;
    const nextStartWeekDate = `${nextDayDates[0].halfMonth} ${nextDayDates[0].date}`;
    const nextEndWeekDate = `${nextDayDates[6].halfMonth} ${nextDayDates[6].date}`;
    
    return (
      <div className="modal fade in build-plan">
        <div className="modal-dialog">
          <div className="modal-content">
            
            <div className="create-plan-popup-box">
          
              <div className="card-bg text-center sample-plan">
                {/* <img src="/images/clos.svg" alt="close" onClick={()=>this.closeBuildPopup()}/> */}
          
                <h4> Welcome to Prep Day! </h4>
                <p> Before we get cookin’, we need to know which week you’d like to create a meal plan for? </p>
                <span className="help-content"><b> WHY?! We’d hate to have you build a plan for the wrong week! </b></span>
                <div className="week-select">
                  <div className="current userProfile">
                    <input type="radio" name="weeks" checked={selectDate==="current"}  onChange={()=>this.updateCheck('current', startWeekDate, endWeekDate, dayDates)} />
                    <span className="radiomark1" />
                    <span className="week-dtl">
                      <span>This Week</span>
                      <span>{startWeekDate}- {endWeekDate}</span>
                    </span>
                  </div>  
                  <div className="next userProfile">
                    <input type="radio" name="weeks"  onChange={()=>this.updateCheck('next', nextStartWeekDate, nextEndWeekDate, nextDayDates)} checked={selectDate==="next"}/>
                    <span className="radiomark1" />
                    <span className="week-dtl">
                      <span>Next Week</span>
                      <span>{nextStartWeekDate}- {nextEndWeekDate}</span>
                    </span>
                  </div>
                </div>
                { error &&  <span className="error-msg"> Please choose one option</span>}
                <div>
                  <button type="button" className="btn btn-success create plan" onClick={()=>this.createPlan(dayDates)}> 
                    Next
                  </button>
                </div>
              </div>
           
          
            </div>
          </div>
        </div>
      </div>

    )
  }

  // eslint-disable-next-line
  createPlan() {
    const { vegan, servingSize, selectWeek, selectDate } = this.state
    let { inputs } = this.state
    const planName = vegan === 'yes' ? 'Plant-Based Sample Plan' : 'Meat-Based Sample Plan'
    // inputs.week_start_date = `${nextDayDates[0].Year}-${nextDayDates[0].Month}-${nextDayDates[0].date}`;
    // inputs.week_end_date = `${nextDayDates[6].Year}-${nextDayDates[6].Month}-${nextDayDates[6].date}`;
    const url = RoutingConstants.sampleRecipe
    if(selectDate != null){
      get(url,'contentful').then(response=>{
        const rIndex = response.items.findIndex(x=>x.fields.planName === planName)
        if(rIndex > -1) {
          for(let i=1; i<5;i+=1) {

            const recipe = response.items[rIndex].fields[`Recipe${i}`] ? response.items[rIndex].fields[`Recipe${i}`] : response.items[rIndex].fields[`recipe${i}`]
          
            if(response.items[rIndex].fields[`recipe${i}PrepDay`] && recipe) {
            // eslint-disable-next-line
            response.items[rIndex].fields[`recipe${i}PrepDay`].map(item=>{
                inputs = this.buildPlan(response, rIndex, item, recipe, 'cooking_data','', 'cooking_date')
                return null;
              })
            }
            if(response.items[rIndex].fields[`recipe${i}Breakfast`] && recipe){
            // eslint-disable-next-line
            response.items[rIndex].fields[`recipe${i}Breakfast`].map(item=>{
                inputs = this.buildPlan(response, rIndex, item, recipe, 'meal_plan_data','Breakfast', 'meal_plan_date')
              })
            }
            if(response.items[rIndex].fields[`recipe${i}Lunch`] && recipe){
            // eslint-disable-next-line
            response.items[rIndex].fields[`recipe${i}Lunch`].map(item=>{
                inputs = this.buildPlan(response, rIndex, item, recipe, 'meal_plan_data','Lunch', 'meal_plan_date')
              })
            }
            if(response.items[rIndex].fields[`recipe${i}Dinner`] && recipe){
            // eslint-disable-next-line
            response.items[rIndex].fields[`recipe${i}Dinner`].map(item=>{
                inputs = this.buildPlan(response, rIndex, item, recipe, 'meal_plan_data','Dinner', 'meal_plan_date')
              })
            }
          }
        }
        const dataUrl = RoutingConstants.addNewPlan
        post(dataUrl,inputs).then(()=>{ 
          history.push('/firstplanweek',{ servingSize, dayDates: selectWeek, planMessage: true, samplePopup: false})
        }).catch(()=>{
          this.setState({ loader: false})
        })
      })
      this.setState({ loader: true, samplePopup: false, planMessage: true })
    } else {
      this.setState({ error: true})
    }
  }

  updateCheck(data, weekStartDate, weekEndDate, selectWeek) {
    const { inputs } = this.state
    inputs.week_start_date = `${selectWeek[0].Year}-${selectWeek[0].Month}-${selectWeek[0].date}`
    inputs.week_end_date = `${selectWeek[6].Year}-${selectWeek[6].Month}-${selectWeek[6].date}`
    // const { selectDate } = this.state
    const dateData = JSON.stringify(selectWeek)
    localStorage.setItem('selectWeek',dateData)
    this.setState({ selectDate:data, inputs, selectWeek })
  }

  // eslint-disable-next-line
  // planMessage() {
  //   return (
  //     <div className="modal fade in build-plan">
  //       <div className="modal-dialog">
  //         <div className="modal-content">
            
  //           <div className="create-plan-popup-box">
          
  //             <div className="card-bg text-center sample-msg">
          
  //               {/* <h4> Welcome to Prep Day! </h4> */}
  //               <p> Thanks! We’re building an example plan with fan favorite recipes to show you the ropes . </p>
  //               {/* <span className="help-content"> We'll use this starter plan to help teach you the ropes! </span> */}
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>

  //   )
  // }

  // eslint-disable-next-line
  buildPlan(response, rIndex,name, recipe, mealType,type, mealDate) {
    const { selectWeek, inputs, servingSize, groceryCategory } = this.state
    // response.items[rIndex].fields[`recipe${i}PrepDay`]
    const cookDInd = response.includes.Entry.findIndex(x=>x.sys.id === name.sys.id)
    if(cookDInd > -1) {
      const cookDateIndex = selectWeek.findIndex(x=>x.fullDay === response.includes.Entry[cookDInd].fields.title)
      if(cookDateIndex > -1){
        const cookDate = `${selectWeek[cookDateIndex].Year}-${selectWeek[cookDateIndex].Month}-${selectWeek[cookDateIndex].date}`
        const inputCookIndex = inputs[mealType].findIndex(x=>x[mealDate] === cookDate)
        const sideInd = response.includes.Entry.findIndex(x=>x.sys.id === recipe.sys.id)
        let sideDishId = null
        console.log(recipe.sys.id,'kl')
        const recipeIngredient = []
        const sideRecipeIngredient = []
        if(sideInd > -1) {
          
          sideDishId = response.includes.Entry[sideInd].fields.recipeSides ? response.includes.Entry[sideInd].fields.recipeSides[0].sys.id : null
          if(response.includes.Entry[sideInd].fields.ingredientsData){
            
            response.includes.Entry[sideInd].fields.ingredientsData.map(ingd=>{
              const ingIndex = response.includes.Entry.findIndex(x=>x.sys.id === ingd.sys.id)
              if((ingIndex > -1) ) {
                const ingNameIndex = response.includes.Entry.findIndex(x=>x.sys.id === response.includes.Entry[ingIndex].fields.ingredient.sys.id)
                // alert('ys')
                if(ingNameIndex > -1){
                  let unit = response.includes.Entry[ingIndex].fields.unit
                  unit = unit === 'empty' ? null : unit
                  const groceryId = groceryCategory.findIndex(x=>x===response.includes.Entry[ingNameIndex].fields.groceryCategory)
                  response.includes.Entry[sideInd].fields.recipeIngredient = []
                  recipeIngredient.push({ 
                    quantity: response.includes.Entry[ingIndex].fields.quantity, 
                    id: ingd.sys.id, 
                    unit,
                    ingredient:{
                      name:response.includes.Entry[ingNameIndex].fields.name,
                      groceryId
                    }
                  })
          
                }
              }
              return ingd;
            })}

          if(sideDishId) {
            const sideIndex = response.includes.Entry.findIndex(x=>x.sys.id === sideDishId)
            if(sideIndex > -1 &&  response.includes.Entry[sideIndex].fields.ingredientsData){
              response.includes.Entry[sideIndex].fields.ingredientsData.map(ingd=>{
                const ingIndex = response.includes.Entry.findIndex(x=>x.sys.id === ingd.sys.id)
                if((ingIndex > -1) ) {
                  
                  const ingNameIndex = response.includes.Entry.findIndex(x=>x.sys.id === response.includes.Entry[ingIndex].fields.ingredient.sys.id)
                  if(ingNameIndex > -1){
                    let unit = response.includes.Entry[ingIndex].fields.unit
                    unit = unit === 'empty' ? null : unit
                    const groceryId = groceryCategory.findIndex(x=>x===response.includes.Entry[ingNameIndex].fields.groceryCategory)
                
                    sideRecipeIngredient.push({ 
                      quantity: response.includes.Entry[ingIndex].fields.quantity, 
                      id: ingd.sys.id, 
                      unit,
                      ingredient:{
                        name:response.includes.Entry[ingNameIndex].fields.name,
                        groceryId
                      }
                    })
                  }
                }
                return ingd;
              })
            }
          }
        }
        if(inputCookIndex === -1) {
          inputs[mealType].push({
            [mealDate]: cookDate, 
            recipes:[{
              recipe_id: recipe.sys.id,
              serving_size: servingSize,
              side_dish_id: sideDishId,
              isBundle : 0,
              meal_plan_type: type
            }]
          }) 
        } else {
          inputs[mealType][inputCookIndex].recipes.push({
            recipe_id: recipe.sys.id,
            serving_size: servingSize,
            side_dish_id: sideDishId,
            isBundle : 0,
            meal_plan_type: type
          })
        }
        
        if(mealType === "meal_plan_data") {
          recipeIngredient.map(value=>{
            let quantity = value.quantity;
            quantity *= (2 / 4);  
            value.unit = value.unit ? value.unit : null    
            const gIndex = inputs.groceryData.findIndex(x=>x.grocery_category_id === (value.ingredient.groceryId + 1) && x.ingredient_name === value.ingredient.name
            && x.measument_unit === value.unit)
            if(gIndex > -1) {
              inputs.groceryData[gIndex].ingredient_quantity += quantity 
            } else {
              inputs.groceryData.push({ 
                grocery_category_id : value.ingredient.groceryId + 1,
                ingredient_name : value.ingredient.name,
                ingredient_quantity :quantity,
                measument_unit: value.unit ? value.unit : null
              })
            }
            return null;
          })
          sideRecipeIngredient.map(value=>{
            let quantity = value.quantity;
            quantity *= (2 / 4);  
            value.unit = value.unit ? value.unit : null    
            const gIndex = inputs.groceryData.findIndex(x=>x.grocery_category_id === (value.ingredient.groceryId + 1) && x.ingredient_name === value.ingredient.name
            && x.measument_unit === value.unit)
            if(gIndex > -1) {
              inputs.groceryData[gIndex].ingredient_quantity += quantity 
            } else {
              inputs.groceryData.push({ 
                grocery_category_id : value.ingredient.groceryId + 1,
                ingredient_name : value.ingredient.name,
                ingredient_quantity :quantity,
                measument_unit: value.unit ? value.unit : null
              })
            }
            return null;
          })
        }
        
        console.log(inputs, recipeIngredient, sideRecipeIngredient)     
      }
    }
    return inputs
  }

  sampleDash() {
    this.setState({ planMessage: false})
  }

  render() {
    const { loader, samplePopup, planMessage, isMobile } = this.state
    const dayDates = JSON.parse(localStorage.getItem('selectWeek'))
    // alert(window.location.pathname)
    const location = {state:{dayDates}, pathname:  window.location.pathname, useFor: planMessage ? "newUser" : (isMobile ? "mobile" : "sample"), samplePopup, planMessage, mobileUser: isMobile ? 'no':'yes'}
    // console.log(dayDates)
    
    return (
      <div>
        {
          loader &&
              <div className="loading" style={{top:"0", padding:"20% 0 0 0"}}>
                <Loader />
                <div className="modal-backdrop fade in custm-bkdrp" />
              </div>
        }
        
        <ReactResizeDetector handleWidth handleHeight onResize={() => this.onResize()} />
        <Dashboard location={location} sampleDash={()=>this.sampleDash()} />
        {samplePopup && !isMobile && this.props.location.pathname === '/newUser' && this.samplePopup()}  
        { planMessage && !isMobile && <PlanMessage/>}
      </div>)
  }
}
export default SampleDashboard


// WEBPACK FOOTER //
// ./src/components/dashboard/SampleDashboard.js